/*
 * why doesnt this component use react-spline/next instead of splinetool/runtime?
 * https://github.com/splinetool/react-spline/issues/203:
 * Using the next version throws an image undefined error on import
 * Using the react-spline package throws an error: ": Cannot find module 'futurium/frontend/node_modules/next/image' imported from …"
 *
 * For now we spline runtime package directly instead of the next version for this package.
 * If you see this comment in the future, try to update the package react-spline and use its next version.
 */

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { StyledSplineScene } from './splineScene.style';
import { breakpoints } from '../../../stylesheets/settings';
import { Application } from '@splinetool/runtime';

const isMobile = () =>
  typeof window !== 'undefined'
    ? window.matchMedia(`(max-width: ${breakpoints?.m || '0px'})`).matches
    : true;

const SplineScene = ({ splineCode, splineCodeMobile }) => {
  const [mobile, setMobile] = useState(isMobile());
  const canvasRef = useRef(null);

  useEffect(() => {
    const onResize = () => setMobile(isMobile());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const scene = mobile ? splineCodeMobile?.at(0)?.src : splineCode?.at(0)?.src;
    if (!scene || !canvasRef.current) return;

    const app = new Application(canvasRef.current);
    app.load(scene);

    return () => {
      app?.dispose();
    };
  }, [mobile, splineCode, splineCodeMobile]);

  const scene = mobile ? splineCodeMobile?.at(0)?.src : splineCode?.at(0)?.src;

  return (
    scene && (
      <StyledSplineScene>
        <canvas ref={canvasRef} />
      </StyledSplineScene>
    )
  );
};

SplineScene.propTypes = {
  splineCode: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
  splineCodeMobile: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string }))
};

export default SplineScene;
